<template>

    <m-edit1/>

    <m-verify-transaction-1 v-bind='{...{},...{}}' :style='""' class="my-5 py-5" ></m-verify-transaction-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mVerifyTransaction1 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/VerifyTransaction/VerifyTransaction1';

export default {
    name: 'HomeView',
    components: {mEdit1, mVerifyTransaction1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
